import type { SVGProps } from 'react'

const Play = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.841 16.9785" {...props}>
        <path d="M1.73711 15.3795C1.73711 16.4465 2.36933 16.9687 3.1248 16.9687C3.45116 16.9687 3.79432 16.864 4.13046 16.6849L15.6656 9.94666C16.506 9.46033 16.841 9.08006 16.841 8.48436C16.841 7.88066 16.506 7.50839 15.6656 7.02031L4.13046 0.283788C3.79432 0.0949216 3.45116 0 3.1248 0C2.36933 0 1.73711 0.520505 1.73711 1.58925Z" />
    </svg>
)
export default Play
